enum StatusProposta {
  Aceita = 1,
  Recusada = 2,
  QuebraDeAcordo = 3,
  PendenteDeRetorno = 4,
  EmAnalise = 5,
  Erro = 6,
  Quitada = 7,
}

export default StatusProposta;
